import api from '../plugins/axios';

function handleError(error) {
  console.error('API Error:', error);
}

export default {
  state: {
    currentUser: null,
    userProfile: null,
    loading: true,
    topPoints: [],
    companyValues: [],
    activity: {},
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setUserProfile(state, user) {
      state.userProfile = user;
    },
    setTopPoints(state, topPoints) {
      state.topPoints = topPoints;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setValues(state, values) {
      state.companyValues = values;
    },
    setActivity(state, activity) {
      state.activity = activity;
    },
  },
  actions: {
    async updateMyAvatar({ dispatch }, avatar) {
      try {
        const resp = await api.put('/profiles/me/avatar', avatar);
        dispatch('settings/updateUser', resp.data, { root: true });
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async loadUserProfile({ commit }, userId) {
      try {
        const resp = await api.get(`/profiles/${userId}`);
        commit('setUserProfile', resp.data);
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async loadTopPoints({ commit, rootState }, userId) {
      try {
        const resp = await api.get(`/leaderboards/${userId}`);
        const pointData = [];
        if (resp.data.length) {
          resp.data.map((data) => {
            const user = rootState.settings.users.find((user) => user.id === data.user_id);
            pointData.push({ ...user, ...data });
          });
        }
        commit(
          'setTopPoints',
          pointData.filter((user) => user.state === 'accepted'),
        );
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async loadUserValues({ commit, rootState }, userId) {
      try {
        const resp = await api.get(`/leaderboards/${userId}/values`);
        let valuesData = [];
        if (resp.data.length) {
          let roundedShares = 0;
          resp.data.map((data) => {
            const value = rootState.auth.values.find((value) => value.id === data.value_id);
            roundedShares += data.share;
            valuesData.push({ ...value, ...data });
          });
          valuesData[0].share += roundedShares > 100 ? -roundedShares % 100 : 100 % roundedShares;
        } else {
          valuesData = rootState.auth.values.map((value) => ({ ...value, share: 0 })).slice(0, 10);
        }

        commit('setValues', valuesData);
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async loadUserActivity({ commit }, userId) {
      try {
        const { data } = await api.get(`/leaderboards/${userId}/activity`);
        if (data.length) {
          const sortedData = data.sort((a, b) => new Date(a[0]).getTime() - new Date(b[0]).getTime());
          const received = sortedData.map((item) => [new Date(item[0]).getTime(), item[1]]);
          const granted = sortedData.map((item) => [new Date(item[0]).getTime(), item[2]]);
          commit('setActivity', { received, granted });
        }
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async updateUserProfile({ dispatch }, user) {
      try {
        const resp = await api.put('/profiles/me', user);
        dispatch('settings/updateUser', resp.data, { root: true });
      } catch (e) {
        handleError(e);
      }
    },
    async init({ dispatch, state }, { id, filter }) {
      const userId = id || state.userProfile.id;
      const params = { url: `/profiles/${userId}/posts?direction=${filter}` };
      await dispatch('feed/init', params, { root: true });
    },
    async loadPosts({ dispatch, state }, { filter }) {
      const params = { url: `/profiles/${state.userProfile.id}/posts`, filter: `direction=${filter}` };
      await dispatch('feed/loadPosts', params, { root: true });
    },
    async loadUserBalanceSheet(_, { userId, nextCursor = 0 }) {
      let url = `/coins/${userId}`;
      if (nextCursor) {
        url += `?next_cursor=${nextCursor}`;
      }
      try {
        const response = await api.get(url);
        return response;
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async getVerificationCodeEmail(_, email) {
      try {
        const { data } = await api.post(`/profiles/me/get_code`, { email });
        return data?.sig;
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
    async verifyCodeEmail(_, { email, code, sig }) {
      try {
        const resp = await api.post(`/profiles/me/verify_code`, { email, code, sig });
        return resp.data;
      } catch (e) {
        handleError(e);
        throw e;
      }
    },
  },
  namespaced: true,
};
